import { render, staticRenderFns } from "./TicketDetail.vue?vue&type=template&id=0d061dc8"
import script from "./TicketDetail.js?vue&type=script&lang=js&external"
export * from "./TicketDetail.js?vue&type=script&lang=js&external"
import style0 from "./TicketDetail.vue?vue&type=style&index=0&id=0d061dc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports